import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';
import { AutofocusDirective } from '../autofocus/autofocus.directive';

@Component({
  selector: 'app-ok-cancel-dialog',
  templateUrl: './ok-cancel-dialog.component.html',
  imports: [TranslateDirective, AutofocusDirective],
})
export class OkCancelDialogComponent {
  protected modal = inject(NgbActiveModal);

  @Input()
  public title!: string;

  @Input()
  public text!: string;
}
